import { Route, Redirect } from "react-router"
import { Query } from "react-apollo"
import React from "react"
import Loading from "../components/Loading"
import GET_VIEWER from "../graphql/getViewer.graphql"
import gql from "graphql-tag"
import qs from "qs"

const REQUIRE_RESET_PASSWORD_QUERY = gql`
  query REQUIRE_RESET_PASSWORD_QUERY {
    viewer {
      id
      isUserAuthenticated
      isDeviceAuthenticated
      requirePasswordReset
    }
  }
`

export const ResetPasswordRoute = ({
  component: Component,
  render,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Query query={REQUIRE_RESET_PASSWORD_QUERY} fetchPolicy="network-only">
          {({ data, loading, error }) => {
            if (
              data &&
              data.viewer &&
              data.viewer.isUserAuthenticated &&
              data.viewer.requirePasswordReset === false
            ) {
              return (
                <Redirect
                  to={{
                    pathname: "/reset-password",
                    state: {
                      from:
                        qs.parse(props.location.search, {
                          ignoreQueryPrefix: true,
                        }).redirect_url || props.location,
                    },
                  }}
                />
              )
            } else if (error) {
              throw new Error(error)
            } else {
              return Component ? <Component {...props} /> : render(props)
            }
          }}
        </Query>
      )}
    />
  )
}

const PrivateRoute = ({ component: Component, render, data, ...rest }) => {
  const { isUserAuthenticated, isDeviceAuthenticated } = data.viewer
  return (
    <ResetPasswordRoute
      {...rest}
      render={(props) =>
        isUserAuthenticated && isDeviceAuthenticated ? (
          Component ? (
            <Component {...props} />
          ) : (
            render(props)
          )
        ) : isUserAuthenticated && !isDeviceAuthenticated ? (
          <Redirect
            to={{
              pathname: "/register-device",
              state: { from: props.location }, // !!
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: props.location.pathname,
                search: props.location.search,
              },
            }}
          />
        )
      }
    />
  )
}

const SemiPrivateRoute = ({ component: Component, render, data, ...rest }) => {
  const { from } = rest.location.state || { from: { pathname: rest.path } }
  const { isUserAuthenticated } = data.viewer
  return (
    <ResetPasswordRoute
      {...rest}
      render={(props) =>
        isUserAuthenticated ? (
          Component ? (
            <Component {...props} />
          ) : (
            render(props)
          )
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from },
            }}
          />
        )
      }
    />
  )
}

export const SemiPrivateRouteWithData = (routeProps) => {
  return (
    <Query query={GET_VIEWER} fetchPolicy="network-only">
      {(queryProps) => {
        if (queryProps.error) {
          throw new Error(queryProps.error)
        }

        if (queryProps.loading && !queryProps.data.viewer) {
          return <Loading />
        }

        return <SemiPrivateRoute {...queryProps} {...routeProps} />
      }}
    </Query>
  )
}

export const PrivateRouteWithData = (routeProps) => {
  return (
    <Query query={GET_VIEWER} fetchPolicy="network-only">
      {(queryProps) => {
        if (queryProps.error) {
          throw new Error(queryProps.error)
        }

        if (queryProps.loading && !queryProps.data.viewer) {
          return <Loading />
        }

        return <PrivateRoute {...queryProps} {...routeProps} />
      }}
    </Query>
  )
}
